import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  resetKey: string;
  fallback: ReactNode;
}
export class ErrorBoundary extends Component<Props, { failed: boolean }> {
  public override state = { failed: false };
  public static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }
  public override componentDidUpdate(previous: Props): void {
    if (this.state.failed && previous.resetKey !== this.props.resetKey)
      this.setState({ failed: false });
  }
  public override render(): ReactNode {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
